import DSBox from "views/system-design/DSBox";

interface IssueSparklineProps {
  /** One event count per bucket, oldest first. */
  counts: number[];
  color: string;
}

const WIDTH = 84;
const HEIGHT = 22;

/**
 * Event volume over the selected window. Bars rather than a line: the series is
 * a count per bucket, and a bar chart does not imply values between buckets.
 */
const IssueSparkline = ({ counts, color }: IssueSparklineProps) => {
  if (!counts.length) {
    return (
      <DSBox sx={{ width: WIDTH, height: HEIGHT, opacity: 0.35, fontSize: 11 }}>
        no data
      </DSBox>
    );
  }

  const peak = Math.max(...counts, 1);
  const barWidth = WIDTH / counts.length;

  return (
    <svg
      width={WIDTH}
      height={HEIGHT}
      viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
      role="img"
      aria-label={`${counts.reduce((sum, count) => sum + count, 0)} events, peak ${peak} in one bucket`}
    >
      {counts.map((count, index) => {
        // Keep a 1px floor so buckets with a few events stay visible.
        const barHeight =
          count === 0 ? 0 : Math.max(1, (count / peak) * HEIGHT);
        return (
          <rect
            key={index}
            x={index * barWidth}
            y={HEIGHT - barHeight}
            width={Math.max(barWidth - 1, 1)}
            height={barHeight}
            fill={color}
            opacity={0.75}
          />
        );
      })}
    </svg>
  );
};

export default IssueSparkline;
